// 《梭哈宣言》v1 — 繁體中文版
// 結構與 MANIFESTO_ZH 完全對齊。
// 作者署名：ALLIN 社群

export const MANIFESTO_ZH_TW = {
  meta: {
    title: '梭哈宣言',
    subtitle: '一份給把全部押在一件事上的人的備忘錄',
    author: 'ALLIN 社群',
    edition: '初版 · 2026 春',
  },
  sections: [
    {
      id: 'preface',
      kind: 'preface',
      number: '',
      title: '前言',
      pullQuote: '梭哈，是這一代人最被誤解的浪漫。',
      paragraphs: [
        '我們想用一句話開宗明義：梭哈，是這一代人最被誤解的浪漫。',
        '這一份不是白皮書。',
        '白皮書會告訴你協議架構、共識機制、Tokenomics 的精妙設計；會畫出一份分四個階段的路線圖，每一步看起來都通向月亮。我們寫不出來這種東西。$ALLIN 不是一個 L1，不是一個 DeFi 協議，沒有什麼「技術突破」——它的合約就是一個標準的 BEP20，樸素得連一行多餘的 require 都沒有。',
        '那為什麼還要發幣？',
        '因為我們想給一種已經存在了幾十年、但從未被認真命名的精神，立一座路標。它在巴菲特身上，在段永平身上，在馬斯克的 2008 年，在雷軍的小米粥，在趙長鵬賣掉的那套上海房子裡。它不屬於哪個國家、哪個行業，但它在每一次偉大決策的背後都出現過。',
        '我們叫它「梭哈」。',
        '代幣是把這種共識標價、確權、記帳最快的方式。這份《梭哈宣言》——以及它所代表的這個專案——是給所有把全部押在一件事上的人的一座紀念碑，也是寫給所有正在那個邊界上猶豫的人的一封信。',
        '如果你讀完之後覺得「這就是我」——歡迎入桌。',
      ],
      sign: '——ALLIN 社群',
    },

    {
      id: 'ch1',
      kind: 'chapter',
      number: 'I',
      title: '為什麼是 ALLIN',
      paragraphs: [
        '我們活在一個鼓勵對沖的時代。',
        '對沖基金管的是錢，但「對沖」早就溢出了金融行業，變成了一種世俗智慧。投資要分散，工作不要 All In 一家公司，關係要保留備胎，時間要切割成多個並行的專案。每個時代都有自己的金科玉律——這一代的金科玉律是「不要把所有雞蛋放在一個籃子裡」。',
        '聽起來很安全。代價是，所有籃子都裝不滿。',
        '我們不反對分散。分散對那些不知道自己在做什麼的人，是最負責任的選擇。它給了一個不會致命的下行邊界。問題是，分散同時也給了一個不會非凡的上行邊界——它把你的人生變成了一種均值回歸的產品。',
        '這一代真正的贏家，沒有一個是分散出來的。',
        '巴菲特的波克夏，在很長一段時間裡，把 70% 的倉位壓在不到十支股票上；那十支裡面，還有一支占了將近一半。這不是分散——這是研究透了之後的集中。段永平在 2001 年把網易當做唯一的押注，全部身家進去，三年回報五十倍。雷軍 40 歲前已經財富自由，他沒有繼續做天使投資人在多個賽道同時下小注，他選擇把自己投到一家公司裡，喝下那碗小米粥。馬斯克在 2008 年只剩下最後一顆火箭可以發射的錢，他沒有把它分成 ABC 三輪「風險測試」，他直接押了第四發。',
        '這些人共享的，不是某種神秘的賭徒人格。恰恰相反——他們都是當時所在行業裡研究最深、資訊最全、風險評估最嚴謹的人之一。他們之所以敢梭哈，是因為他們看清了。',
      ],
      pullQuote: '梭哈不是賭運氣。梭哈是看清楚之後，把全部籌碼推過去的勇氣。',
      paragraphsAfterQuote: [
        '但是這個詞在過去十年裡被反覆汙名化。「梭哈」在很多人耳朵裡等同於「賭徒」、「散戶衝動」、「All in 然後歸零」。這是一種巨大的語義偷換。**真正的梭哈者從不依賴運氣，他們依賴的是研究的深度，加上把研究兌現的勇氣**。運氣派那是另外一群人，叫「賭徒」——他們也常常 All in，但是他們 All in 在一個自己根本看不懂的東西上，所以歸零是必然的。',
        'ALLIN 想做的第一件事，就是把「梭哈」這個詞從賭徒手裡奪回來。',
        '第二件事，是把它從專屬於商業菁英的詞典裡，拿出來交給所有人。',
        '不是只有創業者可以梭哈。一個工程師決定從大廠辭職專心寫自己的開源專案——那是梭哈。一個學生決定大學只學一門，把所有時間倒進 AI 研究——那是梭哈。一個家庭決定賣掉北京的房子全部投入子女在紐西蘭的教育——那是梭哈。一個普通人決定把全部業餘時間和積蓄做一件事十年——那也是梭哈。',
        '梭哈不屬於賽道，不屬於資產規模，不屬於任何身分。它只屬於一種姿態：**研究透、押全部、願賭服輸**。',
        '那為什麼用代幣？',
        '因為代幣是這一代最快的共識容器。一篇文章傳播需要幾年才能形成圈層；一本書需要十年才能塑造一種文化；一種宗教需要百年才能穩定下來。但代幣——一個透明、可交易、鏈上可證、共識可標價的東西——可以在幾個月裡聚集起一群人，讓他們彼此找到、彼此確認。',
        '我們不指望 $ALLIN 解決某個「實際問題」。這枚代幣沒有實用功能。它是一座紀念碑，一種暗號，一份名單——名單上是所有在自己生命裡把全部押在一件事上的人。',
        '最後劃一條線：ALLIN 不是 Trump 主題、不是 Doge 續作、不是任何一隻蹭熱點的 meme。它是中文語境裡**梭哈精神**的一次正式立碑。Logo 上那隻舉拳的金色 Doge，不是借用 Trump 的姿勢——它本身就是這一代人最熟悉的「我看清楚了，我下注」的肢體語言。',
        '它跟 Doge 借用過那個動作，但精神來自更深的地方。',
      ],
    },

    {
      id: 'ch2',
      kind: 'chapter',
      number: 'II',
      title: '三條精神原則',
      paragraphs: [
        '整個專案所有的判斷、所有的決策、所有的內容收錄標準，都來自這三條。',
      ],
      subsections: [
        {
          id: 'ch2-1',
          number: 'I',
          title: '看懂了，就梭哈',
          paragraphs: [
            '這一條決定了我們如何看待「研究」和「下注」的關係。',
            '業內有兩種主流聲音。一種是巴菲特的「安全邊際」——只買那些價格遠低於內在價值的資產，留出足夠緩衝。另一種是段永平的「不為清單」——把自己一輩子不會做的事寫下來，剩下的領域才進入研究範圍。表面看是兩種方法，本質是同一件事：在做出重大決策之前，先把「看不懂的」全部排除乾淨。',
            '排除乾淨之後，會發生一件有趣的事情：可下注的標的變得很少。',
            '少到什麼程度？巴菲特在自己最賺錢的幾十年裡，平均每年只做一兩個真正重大的下注。段永平公開承認過，他人生重大決策不超過五次，每一次都集中下注。這不是因為他們懶——是因為他們知道，**真正能看懂的東西本來就不多**。',
            '這反過來給了一個推論：當你真的看懂一件事的時候，分散下注是一種自我背叛。',
            '如果你研究透了網易，確認它的現金儲備超過市值，你為什麼只買 10%？你既然已經做了 90% 的研究工作，剩下 10% 憑什麼不押上去？除非你懷疑自己的研究——但如果你懷疑，那你應該再研究，而不是用「分散」來掩蓋你的不確定。',
            '凱利公式給這件事提供了數學背書。在已知勝率和賠率的情況下，最優下注比例往往遠高於普通投資者敢押的金額。一個 60% 勝率、1.5:1 賠率的機會，凱利建議下注全部資金的 33%——而不是 5%、不是 10%。',
            '我們說「看懂了就梭哈」，不是鼓勵衝動。是在勸退兩類人：',
          ],
          list: {
            items: [
              '**第一類，你其實沒看懂，但 FOMO 促使你下注。** 那叫賭。回去研究。',
              '**第二類，你看懂了，但只下了一點點。** 那叫怯懦。把它兌現。',
            ],
          },
          paragraphsAfterList: [
            '中間的那條窄路，才是梭哈。',
            '判斷「看懂」的最低門檻，我們建議三條：',
          ],
          checklist: {
            items: [
              '你能用 5 分鐘，對一個聰明但不懂這個領域的人，把它講清楚。',
              '你能列出三種這個押注會失敗的方式，並且知道每一種的機率。',
              '在最壞的情況下，你的生活仍然可以繼續，不會出現「還不上的債」或者「挽不回的關係」。',
            ],
          },
          paragraphsTail: [
            '第三條尤其關鍵。我們不是在鼓勵豪賭——我們是在分清梭哈和豪賭的邊界。真正的梭哈者，押的是「全部可輸的錢」，而不是「全部能借到的錢」。這是一種對自己生活誠實的克制。',
          ],
        },

        {
          id: 'ch2-2',
          number: 'II',
          title: '願賭服輸',
          paragraphs: [
            '這一條決定了我們對自己、對持有人、對市場的態度。',
            'ALLIN 不承諾收益。',
            '我們想把這句話再強調一遍——ALLIN **不**承諾收益。這枚代幣的合約裡沒有質押 APY，沒有回購銷毀機器，沒有定期分紅。我們不會在任何 KOL 的影片裡說「100x 在路上」，也不會在任何 X 貼文裡畫「目標價」。',
            '我們承諾的只有一件事：真實。',
            '合約真實——LP 已經永久銷毀，鏈上可查；分配真實——沒有團隊預留、沒有顧問解鎖；故事真實——所有收錄的梭哈案例都基於公開可驗證的資料。僅此而已。',
          ],
          pullQuote: '我們不賣夢，只賣一份誠實的契約：你看到什麼，就是什麼。',
          paragraphsAfterQuote: [
            '這意味著我們必須主動拒絕兩種行業慣性。',
            '第一種是「路線圖魔法」。絕大多數代幣專案會畫出 Phase 1 / 2 / 3 / 4，每一步都看起來精確、有節奏、不可阻擋。**我們沒有 Phase 4**。我們只承諾當下能落地的事，不承諾一年後會發生什麼——因為社群共識本身是流動的，明年的路線該由明年的社群決定，而不是由今天寫文件的人決定。這聽起來不專業，但它是誠實的。',
            '第二種是「維持共識」。當一個 meme 幣起跑之後，操盤者會做的事情通常是：拉群、喊單、安排買盤、穩住情緒、讓價格不要回調太多。我們不做這些。**ALLIN 的價格漲跌完全反映社群當下的真實信仰強度**——共識強了，價格自然漲；共識弱了，價格自然回。我們不會在它弱的時候用任何手段「托盤」，因為托盤是對持有人最大的不誠實，它製造了一個「還有人在守」的假象，最後買單的還是相信這個假象的人。',
            '願賭服輸的核心，是接受這件事可以歸零。',
            '不是說它一定會歸零，而是說我們——專案方、核心持有人、社群貢獻者——都對這種可能性 100% 知情，並且在知情之後依然選擇留在桌上。這種「在知情之下的留下」，是 ALLIN 唯一可信的護城河。',
            '為持有人提的建議：用你輸得起的錢押。我們說的「輸得起」不是金額——是這筆錢歸零之後你的生活、你的關係、你的健康都不會發生質變。如果你正在用還不起的錢來梭哈，那你不是這份宣言的讀者；你是賭徒。請離開。',
            '公開輸了也是驕傲。',
            '如果有一天 $ALLIN 歸零，社群會公開發布最後一份記錄，列出全部已收錄的故事、全部貢獻者、全部鏈上資料，封檔。它不會偷偷下線，不會改名重啟，不會被洗成另一個專案。**輸了的故事，跟贏了的故事一樣值得被記下來**——因為它們一樣真實地承載了那個時刻把全部押上去的人的勇氣。',
          ],
        },

        {
          id: 'ch2-3',
          number: 'III',
          title: '只做長期主義者的同路人',
          paragraphs: [
            '這一條決定了我們想吸引誰、遠離誰。',
            '最容易被誤解的，是「長期主義」這四個字。它現在被濫用到了幾乎失去意義——拿一支跌了 30% 的股票被套，叫做「長期持有」；做一份七年沒起色的工作還不離開，叫做「長期投入」；維持一段早就互相消耗的關係不分手，叫做「長期承諾」。這些都不是。',
          ],
          pullQuote: '長期主義不是被動等待。長期主義是把每一年都當作可能是最後一年，依然選擇繼續下注。',
          paragraphsAfterQuote: [
            '它是主動的、不斷重新評估的、隨時可以撤出但選擇不撤出的姿態。如果你只是因為「沉沒成本」而不動，那不叫長期主義，那叫慣性。',
            'ALLIN 想找的同路人，是那些把「梭哈」當作一種生活方式而不是一次性事件的人。這意味著：',
          ],
          checklist: {
            items: [
              '他們對自己的研究持續保持懷疑，看到反證會調整。',
              '他們在贏的時候不張揚，在輸的時候不消失。',
              '他們押全部，但永遠只押「下一件最重要的事」，而不是停留在過去的那一件。',
              '他們對其他長期主義者有天然的尊重，哪怕賽道不同、判斷不同。',
            ],
          },
          paragraphsTail: [
            '這就是為什麼 ALLIN 的核心內容，是收錄大佬的梭哈故事。這些故事不是用來「信仰行銷」——它們是給我們和我們的同路人看的備忘錄：**梭哈不是某個時代獨有的，它每一代都有，每個行業都有**。',
            '我們想留下一份長名單。',
            '名單上的人，可能是任正非那樣的工業家、巴菲特那樣的資本家、馬斯克那樣的工程師、孫宇晨那樣的幣圈玩家、王興那樣的連續創業者；也可能是某個我們還沒聽說過的、正在某個小城市的出租屋裡把全部時間砸到一件事上的年輕人。這份名單不分國籍、不分行業、不分階級——唯一的入場券是把全部押在一件事上。',
            '如果你正在做這樣一件事——歡迎來投稿。第三章的《梭哈者列傳》會持續更新，每一條入選的故事都會被永久保留在鏈上和這份宣言裡。我們會用 10% 的代幣池給到入選者。但坦誠說：**真正會被這個專案吸引的人，不是為了那 10%——他們是為了被記下**。',
            '被記下，是一種古老的獎勵。它比 token 古老得多，可能也持久得多。',
          ],
        },
      ],
    },

    {
      id: 'ch3',
      kind: 'chapter',
      number: 'III',
      title: '梭哈者列傳',
      paragraphs: [
        '這一章不是為了崇拜。',
        '我們不想把這九個人神化——他們都有自己的局限、爭議、失誤。任正非以「狼性」著稱但也壓榨過員工；段永平偶爾也會看錯；馬斯克的 X 收購至今爭議不斷；孫宇晨的諸多商業決策被 SEC 起訴。',
        '我們要記下的不是他們這個人，而是他們在某一個具體的瞬間做出的「梭哈」決策。在那一刻，他們都站在懸崖邊上，把全部籌碼推了過去。那一刻的勇氣、那一刻的判斷、那一刻的「看清之後不猶豫」——這些是我們想留下來的。',
        '九個人，九個不同的行業，九種不同的押注。但他們共享一種姿態。',
        '按時間排序——從 1987 年的深圳南油，到 2017 年的鏡頭前。',
      ],
      subsections: [
        {
          id: 'ch3-1',
          number: '01',
          title: '任正非 · 2.1 萬元起家（1987）',
          paragraphs: [
            '1944 年的貴州山區，任正非出生在一個有七個孩子的中學教師家庭。父親教書，母親也是教師，但子女多、收入薄。文革開始後，父親因為「右派」嫌疑被批鬥、隔離、勞改。任正非作為長子，承擔起照顧弟妹的責任。他後來回憶，自己十八歲去重慶建築工程學院讀書前，「從來沒有吃過一頓飽飯」。',
            '1968 年大學畢業，任正非被分配到軍隊基建工程兵部隊，做工程師。從軍 14 年，從普通技術員做到副團級。1983 年部隊整編，他和數十萬軍人一起轉業，安置在深圳南海石油後勤服務基地。',
            '1987 年的某一天，任正非在一筆合作裡被騙走 200 萬元——一筆在當時相當於他幾輩子薪水的金額。妻子提出離婚。父親在貴州老家病逝。43 歲的他，失業、負債、單身，要養活兩個孩子和年邁的母親。',
            '1987 年 9 月 15 日。深圳南山區南油新村 A3 棟 16 樓 16D，一間不到 80 平方公尺的民房。任正非和五個朋友湊了 21,000 元人民幣——其中包括他向親友借的幾千塊——註冊了一家公司。',
            '公司起名「華為」。「中華有為」四個字的簡稱。',
            '第一年，華為只是一家程控用戶交換機的代理商。任正非自己跑業務、談合約、催款、裝機。深圳的夏天 38 度，他穿著襯衫挨家挨戶拜訪客戶。一位早期員工回憶，那時候任老闆「瘦得脫形」。',
            '但代理生意做到第二年，他做了一個改變華為 30 年命運的決定：自研。',
            '當時國內通信市場被「七國八制」壟斷——七個國家的八種制式，全部是西方品牌：朗訊、北電、阿爾卡特、西門子、富士通、易利信、NEC……國產貨寥寥無幾。任正非把代理生意的全部利潤倒進研發。',
            '1991 年下半年，自研產品 HJD48 量產成功。1993 年，華為投入 5000 萬人民幣（相當於公司當年全部利潤）研發萬門程控交換機 C&C08。這是另一次梭哈——研發週期一旦延誤，公司就會破產。',
            '1994 年 C&C08 量產成功。這一年華為銷售額突破 8 億。任正非在年會上說出那句後來被反覆引用的話：',
          ],
          pullQuote: '「十年之內，世界通信製造業三分天下，華為有其一。」',
          paragraphsAfterQuote: [
            '任正非的梭哈不是賭博式的，是絕境式的。1987 年的他沒有「分散下注」的資格——他沒有錢可以分散，沒有第二次機會可以拆分。被騙 200 萬、負債、離婚、父親過世，把他推到了一個「必須 All In 一件事」的位置上。',
            '但他選擇 All In 在哪裡，是經過判斷的。通信行業在 1987 年的中國是一片荒地——一邊是國家急需（電話普及率不到 1%），一邊是國產玩家幾乎為零。任正非看出這是一個 30 年級別的窗口：通信網路一旦建起來，迭代的速度跟基礎設施一樣慢，先發優勢是結構性的。',
            'C&C08 的梭哈則是他第二次「絕境式」決策。1993 年 5000 萬的研發投入，對當時只有 270 名員工的華為來說，是把全部當年利潤押了進去。如果交付失敗——不是延期半年那種失敗，是產品不達標——華為會立刻破產。',
            '後來他自己寫《華為的冬天》《北國之春》——一系列內部講話，全部圍繞一個主題：**危機感是華為唯一的護城河**。',
            '1996 年開始海外擴張，2002 年進入歐洲，2010 年成為全球第二大通信設備商，2018 年超越易利信成為第一。2018 年 12 月孟晚舟在加拿大被捕，開啟美國對華為的制裁。2020 年禁令升級，華為被切斷台積電的晶片供貨。手機業務一度跌掉 70% 收入。',
            '任正非在內部講話裡只說了兩句：「最艱難的時刻還在後面。」「我們要把眼淚擦乾，繼續前進。」',
            '2023 年 8 月 29 日，華為 Mate 60 Pro 在毫無預熱的情況下上市，搭載完全自研的麒麟 9000s 晶片。海外科技媒體一片譁然——華為被認為已經被打死的晶片設計能力，居然以國產製程重生。',
          ],
          checklist: {
            items: [
              '**絕境式梭哈往往最純粹**——你沒有退路，所以你不會猶豫。',
              '**43 歲創業不晚**——把「年齡優勢」拿掉之後，剩下的是判斷力和韌性，那些都不會因為年齡消失。',
              '**選 30 年級別的賽道**——通信、電力、醫療，這些行業的迭代週期長，先發優勢可以累積。',
              '**危機感是護城河**——任正非用 30 年告訴我們，最危險的不是危機本身，是沒有危機感。',
            ],
          },
        },

        {
          id: 'ch3-2',
          number: '02',
          title: '段永平 · 網易抄底（2001）',
          paragraphs: [
            '1961 年江西南昌生。1989 年，28 歲的段永平加入廣東中山一個瀕臨倒閉的小廠——「日華電子廠」。他做的第一件事，是把廠裡一款 8 位元紅白機改頭換面，重新包裝成「小霸王」學習機。1992 年請成龍代言：「擁有一台小霸王，等於擁有一個微機室」。廣告費 5000 萬——當年全中國電視廣告費的零頭。',
            '1995 年小霸王做到 10 億營收。但段永平和老闆談股權改制，老闆拒絕。他選擇帶著核心團隊離開，到東莞創辦「步步高」——做無線電話、複讀機、DVD、後來是音樂手機。同樣請成龍代言，同樣的行銷手法，同樣的現金乳牛。',
            '到 2001 年，40 歲的段永平把步步高的經營權交給團隊，自己移居美國矽谷。他打算「半退休」——讀書、打高爾夫、研究投資。',
            '2001 年是網路泡沫破滅最慘烈的一年。那斯達克從 5048 跌到 1100。中國概念股在美國受到嚴重打擊。',
            '網易（NTES）是其中跌得最慘的一個。2001 年 7 月，網易因為 2000 年報披露不準確被 SEC 調查，股價從 IPO 時的 15 美元一路跌到當年 9 月的 0.6 美元——跌幅 96%。復牌後，幾乎沒有人敢碰這支股票。',
            '段永平剛到美國不久，開始關注美股。他研究網易的財報：',
          ],
          list: {
            items: [
              '公司帳上現金 4400 萬美元',
              '當時市值不到 2000 萬美元',
              '主營遊戲（《大話西遊 II》）、信箱、廣告，都還有正向現金流',
              '創辦人丁磊持股 50%，本人沒跑路',
            ],
          },
          paragraphsAfterList: [
            '簡單說：**這家公司帳上的錢比它的市值還多**。買它，相當於花 5 毛錢買 1 塊錢的現金。',
            '段永平花 200 萬美元買入網易。',
          ],
          pullQuote: '「我對網路懂的不多，但我對人性懂的足夠。」',
          paragraphsAfterQuote: [
            '他的邏輯很簡單。第一，這是典型的「安全邊際」案例——即使網易明天關門，清算之後股東能拿回的錢也比股價多。下行風險被現金鎖死了。第二，丁磊是熟人——段永平在步步高時期跟丁磊有過商業往來，他相信丁磊不是會跑路的人。第三，丁磊正在帶團隊做一款叫《夢幻西遊》的遊戲，公司帳上有錢、有團隊、有產品方向，缺的只是市場情緒。',
            '段永平後來說：「我賭的不是網易必漲——我賭的是哪怕歸零，我也認了。」',
            '他的倉位規模也是關鍵。$200 萬對他來說不是全部身家，但是他單一股票最大倉位之一。這不是分散的「安全邊際」——這是經過研究後的集中下注。',
            '2003 年初，《夢幻西遊》上線，迅速成為中國第一國民端遊。網易股價從 0.6 美元爆發到 70 美元——18 個月，翻了 100 倍。段永平的 200 萬變成了大約 2 個億。但他沒賣。他持有網易長達 20 多年，期間陸續減倉但從未清空。',
            '第二次梭哈在 2011 年。賈伯斯去世，市場擔心蘋果失去靈魂，股價回調。段永平大舉買入蘋果。他的理由：「蘋果的 iOS 生態、產品哲學、用戶黏性，這些不會因為一個人離開而消失。」 10 年後，蘋果股價從他買入的均價漲了 3-4 倍。',
            '中間他還有過一次小賭——2010 年代投資騰訊、2018 年投資茅台。每一次都是研究透了再下大注，沒有一次是分散賭博。',
          ],
          checklist: {
            items: [
              '**現金多於市值的標的，是上帝級別的安全邊際**。這種機會一輩子遇到不超過五次，遇到了不要只下一點點。',
              '**「不為清單」比 to-do list 更重要**。把不會做的領域、不熟悉的行業、看不懂的商業模式，全部排除掉，剩下的才是研究範圍。',
              '**大注 + 長期持有，比短炒賺得多**。段永平這一輩子真正的大決策不超過 5 次，但每次都是大注，並且持有到生意本身改變。',
              '**價值投資 ≠ 不能集中**。巴菲特和段永平都是集中下注派。「分散是無知者的避難所」——巴菲特原話。',
            ],
          },
        },

        {
          id: 'ch3-3',
          number: '03',
          title: '馬斯克 · 第四次發射（2008）',
          paragraphs: [
            '1971 年南非普利托利亞生。10 歲拿到第一台電腦，12 歲靠賣一款叫 Blastar 的遊戲賺到 500 美元。17 歲離開南非去加拿大，因為不想服兵役。',
            '1995 年，24 歲的馬斯克在 Stanford 拿到物理博士專案入學資格，但兩天後輟學，跟弟弟創辦 Zip2。1999 年 Zip2 賣給 Compaq，他個人到手 2200 萬美元。同年他用絕大部分錢創辦 X.com，做線上銀行。後來 X.com 跟 Confinity 合併，改名 PayPal。2002 年 eBay 收購 PayPal，馬斯克作為最大個人股東到手 1.8 億美元。',
            '如果他選擇「分散下注」或「提前退休」，他可以在 31 歲的時候做一輩子的天使投資人。但是他做了相反的事。',
            '2002 年 6 月，他用 1 億美元創辦 SpaceX。2004 年，他用剩下的 7000 萬投資 Tesla，並擔任 CEO。2006 年參與創辦 SolarCity。',
            '到了 2008 年，他三家公司全部瀕臨破產。',
            '2008 年是馬斯克這輩子最接近歸零的一年。SpaceX 已經發射 Falcon 1 三次，三次全部失敗：',
          ],
          list: {
            items: [
              '2006 年 3 月 24 日：發射 33 秒後燃料管路漏油，火箭墜毀',
              '2007 年 3 月 21 日：第一級和第二級分離時碰撞，火箭失控',
              '2008 年 8 月 3 日：第二級提前關機，載荷未能入軌',
            ],
          },
          paragraphsAfterList: [
            'SpaceX 帳上的錢只夠再做最後一次發射。',
            'Tesla 的情況更差。Roadster 跳票一年多，工廠建設超支，2008 年金融危機讓所有 VC 關上了錢包。Tesla 帳上的錢不夠發當月薪水。',
            '馬斯克的 1.8 億美元個人財富——他在 PayPal 賣出之後所有的錢——已經全部投入這兩家公司，外加他自己被燒掉的幾千萬。他在 2008 年 9 月接受採訪時說：「我現在只剩下我妻子的車和孩子的學費基金。」',
            '那個秋天，他做了一個決定：把最後的 3000 萬美元——他全部能動用的現金——全部投入 SpaceX 第四次發射。',
            '2008 年 9 月 28 日，Falcon 1 第四次發射。這一次成功了。Falcon 1 成為人類第一枚由私人公司研發並入軌的液體燃料火箭。緊接著，2008 年 12 月 23 日（聖誕節前兩天），NASA 給 SpaceX 一份 16 億美元的貨運合約。同時 Tesla 在 2008 年 12 月底完成 D 輪 4000 萬美元融資，加上馬斯克自己借來的 2000 萬（用婚戒和房子做抵押），Tesla 撐過了那個聖誕節。',
          ],
          pullQuote: '「我們 either 讓這枚火箭飛起來，要麼這家公司就死了。沒有 third option。」',
          paragraphsAfterQuote: [
            '2008 年 9 月那個梭哈點，馬斯克手裡有幾個選擇：A. 把 3000 萬分成 3 筆給三家公司各一份；B. 全部押給 Tesla，因為汽車行業是更大的市場；C. 全部押給 SpaceX 第四發，賭一次成功。',
            '他選了 C。理由有三：',
            '第一，**SpaceX 的數學是確定的**。火箭技術的失敗模式有限，前三次失敗的原因都已經修復。第四次的勝率是他能夠計算的。Tesla 的市場反應、消費者接受度、金融環境——這些是他算不出來的。',
            '第二，**SpaceX 一旦成功，會立刻拿到 NASA 的合約**。這等於是一筆「如果我贏了，獎金已經在路上」的押注。馬斯克在 2008 年初就跟 NASA 簽了 COTS 專案協議——只要發射成功就能解鎖付款。',
            '第三，**Tesla 還有融資可能，SpaceX 沒有**。VC 不投火箭。SpaceX 必須靠自我證明（一次成功發射）才能改變這一點。',
            '到 2024 年，SpaceX 估值超過 4000 億美元（是世界上估值最高的私營公司），Tesla 巔峰市值超過 1.5 兆美元。但是這些都是「梭哈成功之後的故事」。如果 2008 年 9 月 28 日那次發射失敗，沒有人會記得 SpaceX，Tesla 也會在 2009 年初破產。',
          ],
          checklist: {
            items: [
              '**算的清的賭注，可以集中下**。馬斯克 2008 年敢全押 SpaceX，是因為他能列出第四次發射的所有失敗模式，並且每一種都有解決方案。',
              '**押在「一次成功就改變規則」的事上**。NASA 合約是懸在頭頂的獎勵，馬斯克知道一次發射成功能解鎖多少美元。',
              '**婚戒可以抵押，時間不可以**。當現金不夠的時候資產可以變現；但當時間不夠的時候，沒有任何東西可以替代。',
              '**「All In」不是一次性事件**。馬斯克 2008 年 All In 之後，2018 年 Tesla 量產危機時再次 All In，2022 年收購 Twitter 又一次 All In。',
            ],
          },
        },

        {
          id: 'ch3-4',
          number: '04',
          title: '雷軍 · 一碗小米粥（2010）',
          paragraphs: [
            '雷軍 1969 年生於湖北仙桃，父母都是普通教師。1987 年考入武漢大學計算機系。大三那年（1989 年）他和同學合夥創業，做仿製 BBS 軟體。1991 年 22 歲的他認識金山的求伯君，被吸納進金山。1998 年 29 歲擔任金山 CEO。',
            '在金山的 16 年裡，他帶領團隊推出了 WPS、詞霸、毒霸、劍俠情緣——但跟微軟的對抗一直沒贏，金山始終是中國軟體行業的「老二」。',
            '2007 年 10 月 9 日，金山在港交所上市。雷軍因為身體原因（壓力太大引發的心律問題）辭去 CEO，轉任副董事長。38 歲的他，財富自由，準備半退休。',
            '接下來三年（2007-2010），他成為中國早期最活躍的天使投資人之一。投了 UC 瀏覽器、凡客誠品、YY、多看閱讀、可牛影像、樂淘網等十幾家公司——光 UC 瀏覽器一筆回報就超過 30 億。',
            '但他在 40 歲前夕，開始焦慮。',
            '2010 年 4 月 6 日，北京中關村銀谷大廈 807 室。雷軍和六位合夥人——林斌、黎萬強、周光平、劉德、黃江吉、洪鋒——七個人圍坐在一張桌子前。雷軍端來七碗小米粥。每個人喝一碗。然後開始幹。',
            '公司起名「小米」。「小米加步槍」——農村包圍城市的戰術；同時，小米是「米粒級」的細節工藝——做產品要一顆米一顆米地摳。',
          ],
          pullQuote: '「如果不創業，40 歲之後我都不知道怎麼向自己交代。」',
          paragraphsAfterQuote: [
            '天使投資人的工作是「廣撒網，抓機率」。雷軍在 2007-2010 年的天使投資生涯裡，已經是中國最賺錢的天使投資人之一。如果他繼續做下去，每年躺著賺十幾億是確定的。為什麼放棄這種舒服的生活？',
            '雷軍在多次訪談裡講過：「我做了 18 年工程師，做了 16 年金山 CEO。我一輩子最遺憾的，是沒有做出過一款世界級的產品。我跟比爾蓋茲同時代，我跟賈伯斯同時代，我跟賴利佩吉同時代。但我沒做出一個 Windows，沒做出一個 iPhone，沒做出一個 Google。」',
            '他的判斷是：**行動網路是 30 年級別的窗口**。iPhone 在 2007 年發布，Android 在 2008 年開源，2010 年是中國從功能機切換到智慧型手機的拐點。錯過這一波，下一次機會要等 20 年。**硬體公司用網路模式做，是中國獨有的機會**——中國有最完整的電子供應鏈（深圳）、最大的人口基數、最便宜的渠道成本（網路直銷）。',
            '押全部，是因為他算清了：天使投資可以分散，但創辦一家世界級公司必須 All In。「做產品的人，不能既做這家又做那家。」',
            '2011 年 8 月 16 日，小米手機 1 發布。1999 元定價、雙核處理器、4 英吋螢幕——規格超過當時同價位的所有競品。第一次開放購買，30 萬台手機幾分鐘內售罄。',
            '2018 年 7 月 9 日，小米在港交所上市，市值 540 億美元。雷軍當天的演講流出一句金句：「站在風口上，豬都能飛起來。」',
            '2024 年，雷軍 55 歲的時候，小米 SU7 電動車發布——這是他第二次梭哈。2024 年小米市值重回千億美元級，雷軍成為中國網路新一代的「流量頂流」。',
          ],
          checklist: {
            items: [
              '**財富自由不是終點，是新一輪梭哈的起點**。真正的長期主義者，永遠在梭哈「下一件最重要的事」。',
              '**天使投資和創業不能兩全**。前者要廣，後者要深。雷軍沒有「既做投資人又做 CEO」——他清空了投資身分。',
              '**看準窗口比看準賽道更重要**。雷軍不是第一個看到智慧型手機機會的人，但他是 2010 年那個時間點 All In 進去的少數人。',
              '**40 歲創業不晚，但要梭哈**。任正非 43 歲，雷軍 41 歲，王興 33 歲——把全部押上去的時候，年齡只是數字。',
            ],
          },
        },

        {
          id: 'ch3-5',
          number: '05',
          title: '王興 · 千團大戰末班車（2012）',
          paragraphs: [
            '1979 年福建龍岩生。1996 年從福建龍岩一中考入清華電子工程系。2001 年清華本科畢業，去美國 University of Delaware 讀博士。博士讀了一半，2003 年輟學回國創業。',
            '王興的前 8 年，是連續失敗的 8 年：',
          ],
          list: {
            items: [
              '2003 年，多多友（仿 Friendster）。失敗',
              '2004 年，遊子圖（照片分享）。失敗',
              '2005 年，校內網。在清華、北大火爆，2006 年以 200 萬美元賣給陳一舟（後來改名「人人網」）',
              '2007 年，飯否（仿 Twitter）。2009 年因敏感內容被關停 503 天，黃金窗口期錯過',
              '2008 年，海內（企業版 Facebook）。失敗',
            ],
          },
          paragraphsAfterList: [
            '到 2010 年 31 歲的王興，已經連續創業 8 年，4 次明顯失敗。在矽谷的同齡朋友很多已經是百萬富翁，他還在借錢發薪水。',
            '2010 年 3 月 4 日，王興上線美團網，仿 Groupon 的團購模式。但這次不一樣——2010-2011 年中國掀起團購熱潮，最高峰時全國有超過 5000 家團購網站。整個行業的劇本是：補貼用戶、擴張城市、拉投資、再補貼、再擴張。',
            '王興拒絕了這個劇本。',
            '他做了三件不一樣的事。**不打補貼戰**——所有競爭對手都在做「團購滿 100 減 50」，美團堅持原價 + 商家服務品質。**狠抓 IT 系統**——當所有對手把錢花在地推、廣告、用戶補貼上，美團把一半的錢花在了打磨系統能力。**算帳思維**——每開一個新城市，先看 ROI 模型，模型不通就不開。',
            '2011 年下半年，資本市場對團購模式從狂熱轉向懷疑。VC 的錢開始收緊。到 2011 年底，融不到錢的團購網站開始倒閉。2012 年是行業最慘烈的一年。',
          ],
          pullQuote: '「如果你拒絕失敗，你也就拒絕了成功。」',
          paragraphsAfterQuote: [
            '王興在那一年的內部信裡說：「我們已經撐過了千團大戰。但戰爭不是結束，是開始。」那一年美團沒有大量裁員，沒有撤城，反而開始進軍外送業務——他押的下一個梭哈點。',
            '王興的梭哈不是「全部押在團購」——是「全部押在一家幹十年的服務公司」。在融資緊張的 2011-2012 年，他做了一個反直覺的決定：**留兩個月運營現金，剩下全部投入團隊和系統**。',
            '競爭對手的做法是：帳上有 6 個月的錢，那就花 5 個月燒補貼搶用戶，剩下 1 個月再融資。如果融不到，公司死。',
            '王興的做法是：帳上有 6 個月的錢，留 2 個月當救命糧，4 個月用來雇人、做系統、打基礎。如果融不到，公司還能活 2 個月——這 2 個月裡繼續做產品、做服務，等下一輪機會。',
            '這種演算法聽起來保守，但它本質是另一種 All In——**All In 在「長期主義」這個判斷上**。',
            '2013 年，美團進入外送。2015 年 10 月跟大眾點評合併。2017 年進入打車業務。2018 年 9 月 20 日，美團在香港上市，市值 4000 億港幣。2020 年疫情爆發，美團外送渗透率暴漲，市值峰值超過 2000 億美元。',
          ],
          checklist: {
            items: [
              '**九敗一勝**——如果你只能贏一次，那就一定要贏得徹底。',
              '**現金不是用來花的，是用來撐的**。在沒看清楚戰場之前，留出「夠你看清楚」的現金緩衝。',
              '**不要陪對手玩你不擅長的遊戲**。所有人都在燒錢，你冷靜做產品；所有人在做產品，你冷靜推渠道。永遠在「對手最薄弱的維度」上 All In。',
              '**長期主義本身就是一種押注**。王興梭哈的不是「團購會贏」，而是「用 10 年方式做事的人會贏」。',
            ],
          },
        },

        {
          id: 'ch3-6',
          number: '06',
          title: '趙長鵬 · 賣房梭哈比特幣（2014）',
          paragraphs: [
            '趙長鵬（CZ）1977 年江蘇連雲港生。父親是大學教師，因為政治原因被發配到偏遠地區，1989 年全家移民加拿大溫哥華。',
            '加拿大的青少年時代，CZ 在麥當勞打工、加油站值夜班、東京的壽司店做學徒——典型的「窮移民第二代」。1996 年考入麥基爾大學（McGill）計算機系，畢業後進入彭博（Bloomberg），做交易系統的工程師。2005 年，他離開彭博創業，做高頻交易系統 Fusion Systems，客戶是華爾街的對沖基金。',
            '2013 年的某天，CZ 跟一個朋友吃晚飯。那個朋友花了一整頓飯跟他講比特幣。CZ 當時的反應：完全不理解。',
            '但是幾天後，他研究了比特幣的白皮書。再過幾天，他讀完了 Andreas Antonopoulos 的《Mastering Bitcoin》。再過幾週，他飛到上海，找到 OKCoin（徐明星的），說他想加入。',
            '2014 年，CZ 在上海有一套房產（具體地點他沒公開過，估計是市區）。他賣了。全部資金換成比特幣。',
            '2014 年比特幣價格在 200-700 美元之間波動（年初 800，年中 600，年底 320）。CZ 沒有公開過他買入的均價，但根據 2014 年中位數估算，他大概買了 1000-3000 枚 BTC。',
            '這件事在 2014 年沒什麼人知道。直到 2018 年 CZ 接受訪談被問到：「你最 All In 的一次決定是什麼？」他才說：「2014 年我把上海的房子賣了，全部買了比特幣。」',
          ],
          pullQuote: '「我賭的不是比特幣會漲。我是賭——加密貨幣會改變金融基礎設施這件事一定會發生。」',
          paragraphsAfterQuote: [
            '「——可能 5 年，可能 10 年，可能 20 年，但一定會發生。如果發生，比特幣是這個新世界裡最確定的資產。如果不發生，那我就當我捐了一套房子。」',
            '那時候他已經在 OKCoin 工作，2015 年又去了 Blockchain.info。他不是炒幣的人——他是搭建基礎設施的人。',
            '2017 年 5 月，CZ 離開 OKCoin。6 月 26 日，幣安（Binance）ICO 啟動，募資 1500 萬美元。7 月 14 日，幣安交易所正式上線。11 個員工。一個簡單的網站。一個簡單的承諾：低手續費、多幣對、技術穩定。',
            '2017 年 9 月 4 日，中國 7 部委聯合發布《關於防範代幣發行融資風險的公告》，全面禁止 ICO 和加密貨幣交易所。幣安剛上線兩個月，就要面對生死劫。',
            'CZ 的反應：當晚搬到日本。三天後整個團隊從中國分散到東京、香港、馬爾他、新加坡。幣安成為一家「無國籍」公司。到 2017 年底，幣安日活用戶突破 600 萬，成為全球第一大加密交易所。從啟動到第一不到 180 天。',
            '2014 年賣房和 2017 年創辦幣安，是同一種思維的兩次執行。**賭「基礎設施」而不是「價格」**——CZ 從來沒說過比特幣會到 10 萬美元，他只說過「加密金融基礎設施一定會被建起來」。**當所有人都在害怕監管的時候，All In 監管套利**——2017 年中國禁令，是幣安的最大機會，不是最大威脅。**把「無國籍」做成競爭力**——幣安從第一天起就有 8 個國家的員工、4 種語言的客服、30+ 法幣入金通道。',
            '2022 年 11 月 8 日: FTX 暴雷，CZ 拒絕救援，加速 SBF 倒台。幣安趁勢進一步搶市場。2023 年 11 月 21 日: 美國司法部宣布幣安和 CZ 認罪，繳納 43 億美元罰款。CZ 辭去 CEO 職位，被判刑 4 個月。2024 年 4 月 CZ 服刑結束，下半年再次活躍，幣安繼續是全球最大交易所。',
          ],
          checklist: {
            items: [
              '**賣了房子的人不會回頭**。CZ 2014 年賣房之後，再也沒有「如果哪天我想退出還能回去」的退路——他被自己鎖死了。這種鎖死，往往是最大的執行力來源。',
              '**賭長期敘事而不是短期價格**。比特幣 2014 年到 2024 年漲了 100 倍。但如果 CZ 當時是為了「漲 10 倍就賣」才買的，他早就退出了。買入「我不賣」才是真梭哈。',
              '**監管是機會，不是威脅**。每一次大監管事件，都會讓一批「半信半疑」的玩家退出，留下「完全信」的玩家拿到所有市場。',
              '**基礎設施 > 資產價格**。CZ 沒有押 BTC 漲多少，他押的是「加密交易所」這個基礎設施位置。結果是 BTC 漲 100 倍，幣安漲 1000 倍。',
            ],
          },
        },

        {
          id: 'ch3-7',
          number: '07',
          title: '黃崢 · 三次重啟（2015）',
          paragraphs: [
            '1980 年浙江杭州生。父母都是普通工人。從小成績好，1998 年保送杭州外國語學校（杭外）。在杭外認識了一個改變他一輩子的人——段永平。兩人通過一次校園活動認識，段永平當時已經是步步高的老闆，回母校做客。',
            '2002 年浙大計算機本科畢業，黃崢獲得段永平資助去 University of Wisconsin-Madison 讀計算機碩士。2004 年碩士畢業，加入 Google 中國早期團隊。',
            '2006 年 Google 在巴菲特午餐拍賣會上，段永平出資 62 萬美元拍下機會，把黃崢帶去見巴菲特和蒙格——這是黃崢商業人生最重要的一課。',
            '2007 年 27 歲，黃崢從 Google 離職，第一次創業：歐酷網。2009 年 4500 萬美元賣給蘭亭集勢。2009 年第二次創業：樂其代運營公司——幫寶潔、聯合利華做電商代運營。2013 年第三次創業：尋夢遊戲。',
            '到 2015 年 35 歲的黃崢，已經創辦過三家公司：歐酷（賣掉）、樂其（盈利運營）、尋夢（盈利運營）。手上有錢、有團隊、有資源。如果繼續做這三家，他可以一輩子衣食無憂。但他做了第四次重啟。',
            '2015 年 9 月，黃崢同時孵化兩個新專案：拼好貨（生鮮電商）和拼多多（雜貨電商）。2016 年 9 月合併為「拼多多」。',
            '為什麼是拼團？為什麼是下沉市場？',
            '2015 年的中國電商已經是雙寡頭：京東 + 阿里。市場普遍認為，電商行業再沒有創業機會。黃崢看到的不一樣——「京東和阿里服務的是中國 5 億城市人口。還有 5 億農村和三四線人口，他們的需求和購買力沒有被任何人服務。」',
          ],
          pullQuote: '「保持常識，遠離喧囂。」',
          paragraphsAfterQuote: [
            '拼多多的設計：**拼團**——利用社交關係裂變，降低獲客成本到極致。**微信生態**——不開發獨立 App，直接寄生在微信裡。**白牌商品**——不賣品牌貨，賣工廠貨，價格壓到京東淘寶的一半。**演算法分發**——不做搜尋，做推薦，讓用戶「刷」商品。',
            '所有這些選擇都被同行嘲笑。「拼夕夕」、「假貨」、「不上檔次」——拼多多被罵了三年。但是用戶在漲。2017 年拼多多年 GMV 突破千億。',
            '黃崢的梭哈，是把「商業常識」全部押在了一個被嘲笑的方向上。**不打主流市場**——當所有人都盯著北上廣深的菁英用戶，他押五環外人口。**反 App 思維**——當所有電商都在做獨立 App，他押微信生態。**反品牌思維**——當所有電商都講「消費升級」，他押「消費降級」。**反搜尋思維**——當所有人都用搜尋框做分發，他押演算法推薦。',
            '每一條都是反主流。每一條都是基於他對「非網路原住民」的深刻洞察。',
            '而且他自己有「段永平 + 巴菲特 + 蒙格」三層導師。這三個人共同教會他一件事：**當你的邏輯跟主流相反的時候，先問「我看錯了什麼」，問完之後如果還堅持原判斷，就 All In**。',
            '2018 年 7 月 26 日，拼多多在那斯達克上市，市值 240 億美元。當天黃崢 38 歲。2020-2021，拼多多 GMV 一度超越京東。2024 年拼多多市值峰值超過 2200 億美元，海外品牌 Temu 在美國衝擊亞馬遜。',
            '2021 年 3 月，41 歲的黃崢宣布辭去 CEO，轉入科研——投入生命科學和食品科學。他在公開信裡說：「我累了。我想用剩下的人生研究我真正好奇的事。」',
          ],
          checklist: {
            items: [
              '**重啟不丟人**。黃崢 35 歲的時候已經做了三家公司，他沒有「在路徑依賴裡繼續」。每一次他都問自己：「這是不是 10 年後還想做的事？」',
              '**反主流的判斷需要更深的研究**。如果你的結論跟所有人都不一樣，那要麼你看到了別人沒看到的，要麼你看錯了。多問自己幾遍「我可能錯在哪裡」。',
              '**導師的複利**。段永平 → 巴菲特 → 蒙格，三層導師把價值投資的世界觀完整傳遞給了黃崢。重要決策時，能借用別人 50 年的智慧。',
              '**退出比進場難**。黃崢 41 歲退休去做科研，是另一種意義上的梭哈——把後半生 All In 在一件不會立刻有回報的事上。',
            ],
          },
        },

        {
          id: 'ch3-8',
          number: '08',
          title: '張一鳴 · 抖音出海（2016）',
          paragraphs: [
            '1983 年福建龍岩生。跟王興是龍岩老鄉，都畢業於龍岩一中。父親是機關幹部，母親是護士。',
            '2001 年考入南開大學微電子專業，因為對軟體更感興趣，2003 年轉專業到軟體工程。在南開期間他讀完了幾乎所有計算機經典，並開始為開源專案貢獻程式碼。',
            '2005 年畢業。2005-2009 期間換了幾家公司：IBM 實習（無聊辭職）、酷訊旅遊搜尋（一年從工程師做到技術主管）、飯否（王興的第二家公司）、九九房（自己創業）。',
            '到 2011 年 28 歲，張一鳴已經歷 4 家公司、3 次明顯失敗。他在反思一件事：**為什麼網路行業的所有內容分發，都還是編輯推薦？**',
            '2012 年 3 月 9 日，字節跳動成立。同年 8 月，今日頭條 1.0 上線。',
            '今日頭條的核心創新是：**演算法推薦，不是編輯推薦**。這在 2012 年的中國是離經叛道。當時所有內容平台——新浪、網易、搜狐、騰訊——都是編輯選稿、首頁置頂、用戶被動接受。演算法推薦被視為「低俗」、「標題黨的溫床」、「機器無法理解內容」。',
            '張一鳴的判斷：演算法 + 資料 = 比編輯更懂用戶。',
            '但前兩年不順利。2012-2013 頭條增長緩慢，融資被拒了幾十次（大部分 VC 不相信演算法推薦能成主流）。2014 年 6 月紅杉投資頭條 C 輪，估值 5 億美元，是演算法路線的第一個大玩家。2014-2016 是頭條爆發期。月活用戶從 1000 萬漲到 1.5 億。',
            '2016 年 9 月，字節跳動上線短影音 App，改名「抖音」。2017 年抖音 DAU 突破 5000 萬，2018 年突破 2 億。',
            '但更關鍵的決定，是出海。',
            '2017 年 11 月，字節跳動以 10 億美元收購 Musical.ly。2018 年 8 月把 Musical.ly 跟海外版抖音合併為 TikTok。',
            '那時候字節跳動帳上的錢不超過 30 億美元。這一筆 10 億收購，是把帳上 1/3 的錢押在了一件沒人確定能成的事上——中國 App 出海到歐美 C 端市場，從來沒成功過（微信、QQ 在海外市場都失敗了）。',
            '張一鳴卻把字節跳動接下來 5 年的資源和人才 70% 傾斜到了 TikTok。',
          ],
          pullQuote: '「延遲滿足感，是把人生當作一場無限遊戲來玩的能力。」',
          paragraphsAfterQuote: [
            '張一鳴的「延遲滿足感」哲學，在出海這件事上體現得最明顯。2016-2017 年的中國網路，所有人都在搶「國內 BAT 之外的紅利」。但張一鳴判斷：',
            '第一，**國內市場的天花板不夠高**。今日頭條已經做到中國 1.5 億月活，再漲空間有限。',
            '第二，**演算法 + 短影音 + 推薦流，是普世內容產品**。這個組合不依賴於具體的中國國情，理論上可以服務全世界。',
            '第三，**沒有任何中國網路公司在 C 端真正打入歐美**。如果有人能做到，那就是這一代裡最大的紅利。',
            '第四，**出海賭的不是市場份額，是話語權**。一個中國公司在美國市場拿到 1 億用戶，等於一個新冷戰時代的「軟實力武器」。',
            '押 70% 的資源給一個不確定的事，只有相信「延遲滿足感」的人才做得到。',
            '2019 年 TikTok 在美國 DAU 突破 4000 萬。2020 年川普想禁 TikTok，最終未成。2021 年 TikTok 全球月活突破 10 億。2024 年字節跳動估值約 3000-5000 億美元（一級市場估值）。',
            '2021 年 5 月 20 日，張一鳴 38 歲，宣布辭去 CEO，由梁汝波接任。他在內部信裡說：「我想放下日常管理，去思考一些 5-10 年的事。」',
          ],
          checklist: {
            items: [
              '**演算法是這個時代最被低估的人類發明**。2012 年的張一鳴判斷「演算法 + 內容」會重塑分發權，10 年後這個判斷價值兆元。',
              '**延遲滿足感不是不下注，是下大注**。看似「等」的人，往往在等到位之後下了別人想都不敢想的注。',
              '**國際化不是銷售擴張，是產品基因**。從第一天就為全球設計的產品，10 年後能拿全球。從中國市場起家再考慮出海的產品，幾乎都會卡在文化壁壘上。',
              '**反共識三次以上的人才能成大事**。演算法推薦反 2012 共識、抖音反 2016 短影音共識、出海反 2017 中國網路共識。每次都對了。',
            ],
          },
        },

        {
          id: 'ch3-9',
          number: '09',
          title: '孫宇晨 · 鏡頭前的梭哈（2017）',
          paragraphs: [
            '1990 年青海西寧生。父親是中學語文老師。高中開始寫作，2007 年獲得新概念作文一等獎。2008 年從北京大學歷史系本科入學。2013 年北大本科畢業，去美國賓夕法尼亞大學讀碩士。',
            '2013 年加入 Ripple 擔任大中華區代表。兩年後離職，自己單幹。',
            '2017 年 8 月 28 日，27 歲的孫宇晨發起波場（TRON）的 ICO，募集 7000 萬美元。2017 年 9 月 4 日，中國 7 部委聯合發布《關於防範代幣發行融資風險的公告》。所有 ICO 專案被要求停止募資、退還資金。波場首當其衝。外界普遍認為：波場已死。',
            '但孫宇晨沒有走傳統路線。他在鏡頭前——多次直播、多次訪談——明確表態：「All In! 我個人全部身家都在波場上。」',
            '這不是行銷話術。這是一種姿態——把自己的退路徹底燒掉，讓所有可能猶豫的投資人和持有者看到：「我沒有 plan B。」',
            '2018 年 6 月 25 日，TRON 主網正式上線。同年 7 月，TRON 收購 BitTorrent（1.4 億美元），成為加密圈第一筆大型併購。',
            '2018 年底波場已經是全球前十的公鏈，TRX 流通市值最高超過 100 億美元。',
          ],
          pullQuote: '「All In!」',
          paragraphsAfterQuote: [
            '孫宇晨的梭哈，是有爭議的——業內對他評價兩極。但拋開爭議看決策，他的「All In!」姿態本身改變了幾件事。',
            '第一，**讓「梭哈」這個詞在中文加密圈固化**。在他之前，中文圈的對應詞是「梭哈」或「重倉」，但都不夠口號化。他在鏡頭前喊出 「All In!」 之後，這兩個英文字母成了一種文化符號。',
            '第二，**用「個人 All In」代替「團隊 All In」**。傳統創業專案都是團隊信用，但波場是孫宇晨一個人的信用。他賭的是：如果你相信我，你就持有 TRX。如果你不相信我，你就走。這種激進的「個人化承諾」，成為後來很多 meme 幣和加密 KOL 專案的模板。',
            '第三，**監管打壓期反向行動**。2017 年 9 月禁令之後，理性反應是退出市場、轉型、收縮。孫宇晨的反應是：搬到海外、加碼投入、加倍曝光。這種「逆向 All In」，跟馬斯克 2008 年押第四發是同一種邏輯——別人在撤退的時候，你 All In。',
            '2019 年 6 月，孫宇晨花 457 萬美元拍下「巴菲特午餐」——史上最高價。後因身體原因推遲，2022 年 5 月才完成。',
            '2020-2021 加密大牛市，TRX 漲幅可觀，TRON 成為 USDT 主要發行鏈（峰值時 TRC20-USDT 流通超 500 億美元）。但爭議持續。2023 年 SEC 起訴孫宇晨涉嫌操縱市場。USDD 演算法穩定幣在 2022 年面臨脫錨危機。',
            '到 2024-2025 年，TRX 仍是全球前十大幣種之一，孫宇晨仍然是加密圈最具話題性的中國創業者。',
          ],
          checklist: {
            items: [
              '**公開 All In 是一種自縛式承諾**。當你在鏡頭前說出「我全部身家都在這」，你就給自己做了一個不能反悔的承諾。這種「自縛」本身是執行力。',
              '**「梭哈」作為文化符號的力量**。一個詞、一個口號、一種姿態，有時候比商業模式更能聚集共識。',
              '**爭議 + All In 共存**。每一個把全部押上去的人，都會有爭議。如果一個創業者從來沒被罵過，可能是因為他沒真的押上全部。',
              '**逆向行動是 All In 的基本姿勢**。監管禁令、市場恐慌、輿論圍剿——這些時刻反而是 All In 的最佳窗口。',
            ],
          },
        },
      ],
      paragraphsTail: [
        '九個故事講完了。',
        '我們沒有收錄所有應該被收錄的人。這一卷是一個開始——後續每一篇社群投稿入選的故事，都會編入這份名單的延續。',
        '如果你身邊有這樣的人，或者你自己就是這樣的人——請投稿。',
        '一份長名單，剛剛開始。',
      ],
    },

    {
      id: 'ch4',
      kind: 'chapter',
      number: 'IV',
      title: '社群共建',
      paragraphs: [
        'ALLIN 不是一個人能寫完的專案。這一章講清楚：你怎麼貢獻，我們怎麼收錄，激勵怎麼發。',
      ],
      subsections: [
        {
          id: 'ch4-1',
          number: 'i',
          title: '誰可以投稿',
          paragraphs: [
            '任何人都可以投稿一個梭哈故事。',
            '我們接受三種來源：',
          ],
          checklist: {
            items: [
              '**個人故事**——你自己經歷過的梭哈時刻',
              '**親歷者代筆**——你身邊的人經歷過的、你願意為他寫的故事',
              '**研究式投稿**——你研究過的某個公開人物的梭哈時刻，且引用資料可以追溯到原始來源',
            ],
          },
          paragraphsTail: [
            '第三類是目前《梭哈者列傳》主要的來源。第一類正在快速增長——我們已經收到了幾十份匿名投稿，正在評審。',
          ],
        },
        {
          id: 'ch4-2',
          number: 'ii',
          title: '入選標準',
          paragraphs: [
            '不是每一次「All in」都算梭哈。我們的入選標準很嚴格。一個故事要被收錄，必須滿足下面三條**全部**：',
          ],
          checklist: {
            items: [
              '**條件一 · 必須押「全部可輸的」**——押了 10% 不算梭哈，押了 50% 也不算。必須是「如果失敗，將立刻陷入實質性困境」的程度——賣掉房子、清空帳戶、抵押資產、放棄穩定收入、推掉所有備選項。我們要看到具體的資產數字、收入斷流、退路被切。',
              '**條件二 · 必須有明確的決策時刻**——「我做了 10 年這件事」不算梭哈。我們要看到一個具體的時刻：某一天、某一個會議、某一句話、某一個簽字——決策被做出了。這個時刻可能是「早上喝粥的那一刻」，可能是「晚上簽合約的那一刻」。但必須是一個時間戳。',
              '**條件三 · 必須有可驗證的結果**——不論結果是成功還是失敗，必須有公開可查的「後續」：產品上線了、公司倒閉了、市值變了、資金流向變了。失敗的故事跟成功的一樣有價值，前提是失敗本身可以被誠實記錄下來。',
            ],
          },
          paragraphsTail: [
            '三條缺一不可。',
            '我們也會收錄「失敗的梭哈」——這種故事不應該被埋掉。一個把全部押上去然後輸掉的人，跟一個把全部押上去然後贏的人，承擔的勇氣是一樣的。',
          ],
        },
        {
          id: 'ch4-3',
          number: 'iii',
          title: '投稿流程與激勵',
          paragraphs: [
            '準備 1500-2000 字的中文故事，按「背景 / 關鍵時刻 / 決策邏輯 / 後續 / 啟示」五段結構。引用至少 3 個公開來源（個人故事可以是當事人親述 + 時間戳；公開人物必須是新聞、年報、傳記等可驗證資料）。投稿到 Telegram（@allin_submissions）或 GitHub PR（allin/manifesto repo）。社群匿名評審，通常 2-4 週給出回覆。',
            '社群池一共 10% 的代幣，合約確認後會單獨地址鎖定。分配方式：',
          ],
          checklist: {
            items: [
              '每一個被收錄的故事，作者獲得固定 30 萬 ALLIN 基礎獎勵',
              '每被引用 / 轉發 / 翻譯 1000 次，作者額外獲得 5 萬 ALLIN',
              '翻譯者（中→英、中→其他語言）獲得原作者 30% 的獎勵比例',
              '前 100 篇收錄的故事，作者獲得「創世貢獻者」標識——鏈上 NFT，永久銘牌',
            ],
          },
          paragraphsTail: [
            '但坦誠說：金額不是重點。被收錄在這份宣言裡、被鏈上永久記錄、被所有未來的 ALLIN 持有者讀到——這才是核心激勵。',
            '關於治理：ALLIN 不是 DAO，不會做「代幣投票治理路線圖」那種秀。但我們會做下面這些：入選標準的修訂，由社群核心貢獻者集體討論。重大決策（例如未來融資、是否上 CEX）通過社群簽名公告。代幣分配的執行，每月鏈上公開記錄。任何修改宣言文字的提議，必須經過 14 天公示期。',
          ],
          pullQuote: '少做承諾，做了就兌現。',
        },
      ],
    },

    {
      id: 'ch5',
      kind: 'chapter',
      number: 'V',
      title: '機制與透明度',
      paragraphs: [
        '這一章本來可以寫很長——把鏈、合約、分配、安全審計、流動性證明全部展開。但我們選擇寫短。',
        '因為這些東西，鏈上一查就有，不需要我們用文字再描述一遍。',
      ],
      subsections: [
        {
          id: 'ch5-1',
          number: 'i',
          title: '基礎資訊',
          checklist: {
            items: [
              '**鏈** · BNB Chain（BSC）',
              '**合約地址** · 0x234c3bFC260277cb4497E498A83aB685E30Ac730',
              '**代幣標準** · BEP-20',
              '**總供應量** · 1,000,000,000 ALLIN',
              '**小數位** · 18',
              '**DEX** · PancakeSwap V2',
              '**交易對** · ALLIN/USDT，pair address 0xa6c24770d62b156115198de3fcc9be9e70bf975e',
              '**行情數據** · DexScreener / GeckoTerminal / CMC（陸續上線）',
            ],
          },
        },
        {
          id: 'ch5-2',
          number: 'ii',
          title: '代幣分配',
          paragraphs: [
            '**公開流動性 85%**——上線即注入 PancakeSwap，LP 永久銷毀。鏈上可證明的銷毀交易記錄在合約創建後 24 小時內執行。',
            '**社群激勵 10%**——用於《梭哈者列傳》投稿激勵、翻譯激勵、社群貢獻獎勵。地址公開，每月鏈上記錄支出。',
            '**市場曝光 5%**——用於 KOL、媒體、社群活動。地址公開，每一筆支出在 24 小時內推特公示。',
            '**團隊預留 0%**——沒有。我們不留。',
          ],
        },
        {
          id: 'ch5-3',
          number: 'iii',
          title: 'LP 銷毀與資料看板',
          paragraphs: [
            'LP 銷毀的交易 hash 鏈上可查。這是最關鍵的一筆交易——它證明了我們沒有「撤池子」的能力。任何人都可以在 BscScan 上驗證：合約創建 → 添加流動性 → 把 LP 代幣轉入 0x000…dead 地址。',
            '如果你看不懂這些技術細節，你只需要記住一件事：**LP 銷毀之後，這枚代幣的池子永遠不會被專案方撤走，任何人都不會**。',
            '官網首頁的四個即時資料卡——市值、持有人數、24h 交易量、池子 USDT——資料來自 DexScreener API + GoPlus Security API。每 60 秒自動刷新，瀏覽器開發者工具可以驗證請求。任何人發現資料異常，可以在 Telegram 反饋。',
          ],
        },
        {
          id: 'ch5-4',
          number: 'iv',
          title: '我們沒有的',
          paragraphs: [
            '為了讓你確切地知道這枚代幣是什麼，我們也列一下「我們沒有的」：',
          ],
          checklist: {
            items: [
              '沒有審計——合約太簡單，60 行程式碼內可讀完，一個標準 BEP-20 加 LP 銷毀',
              '沒有質押合約',
              '沒有鎖倉機制（除了 LP 永久銷毀）',
              '沒有跨鏈橋',
              '沒有 governance token——持有 ALLIN 不會給你投票權',
              '沒有空投承諾——從來沒說過會空投，將來也不會突然宣布',
            ],
          },
          paragraphsTail: ['簡單是這枚代幣的設計原則。'],
        },
      ],
    },

    {
      id: 'ch6',
      kind: 'chapter',
      number: 'VI',
      title: '這不是什麼',
      paragraphs: [
        '這一章用來劃清邊界。',
        '在加密世界裡，每一個新代幣都會被以下問題轟炸：你是不是 L1？你解決什麼問題？你有什麼 utility？你跟某某專案什麼關係？',
        '為了讓所有人都不再問這些問題，我們直接答清楚。',
      ],
      subsections: [
        {
          id: 'ch6-1',
          number: 'i',
          title: '我們不是',
          checklist: {
            items: [
              '**不是 L1**——我們不是新一條公鏈，我們就是 BNB Chain 上的一枚 BEP-20 代幣',
              '**不是 DeFi 協議**——沒有 lending / swap / staking / yield 任何金融功能',
              '**不是 RWA token**——沒有抵押任何現實資產',
              '**不是 governance token**——持有它不會給你任何專案投票權',
              '**不是 utility token**——它沒有具體的「使用場景」，你不能用它解鎖任何功能、買任何商品、獲得任何服務',
              '**不是空投幣**——沒有空投計劃，也不會有「突然宣布」的空投',
              '**不是任何熱點的拼接**——RWA / IDO / Restaking / DePIN，這些跟 ALLIN 都沒關係',
            ],
          },
        },
        {
          id: 'ch6-2',
          number: 'ii',
          title: '那 ALLIN 是什麼',
          paragraphs: [
            'ALLIN 是一座紀念碑。一份名單。一種暗號。',
            '它的全部價值，來自持有者對「看懂了就梭哈」這種精神的認同。它沒有承諾收益，沒有實用功能，沒有未來路線圖。',
            '這聽起來不像投資標的。是的，**它本來就不是**。',
          ],
          pullQuote: '它的價值不是金融式的，是文化式的——你認同這種精神，你就買；你不認同，你就走。',
        },
        {
          id: 'ch6-3',
          number: 'iii',
          title: '關於風險與司法管轄',
          paragraphs: [
            '這枚代幣可以歸零。',
            '如果某一天 ALLIN 的市場不再相信這種精神，價格會歸零。如果某一天社群共識潰散，價格會歸零。如果某一天監管完全禁止此類社群代幣，價格會歸零。',
            '我們對這種歸零 100% 知情，並且把這種「歸零的可能性」寫進了所有公開材料裡。',
            '請用你輸得起的錢押。',
            'ALLIN 不是任何司法管轄區的證券要約。本宣言不構成投資建議、不構成要約、不構成勸誘購買。如果你所在的國家或地區禁止持有加密資產，請遵守你當地的法律。ALLIN 不會主動進入任何明顯違反加密監管的市場。',
          ],
        },
      ],
    },

    {
      id: 'postscript',
      kind: 'chapter',
      number: '',
      title: '後記',
      paragraphs: [
        '如果你讀到這裡——',
        '你已經知道了《梭哈宣言》的全部內容。前言、為什麼是 ALLIN、三條精神原則、九個人的故事、社群共建規則、機制透明度、和這枚代幣不是什麼。',
        '我們不再說服你。',
        '如果這份文字打動了你，歡迎入桌。買一些 ALLIN，加入 Telegram 社群，給我們投稿你身邊的梭哈故事，或者，乾脆什麼都不做——只是把這份宣言轉發給一個你認識的、正在懸崖邊上猶豫的朋友。',
        '如果這份文字沒有打動你，沒關係。這本就不是一份給所有人的文字。',
        '我們想留下的，不是一個十億美元的 token，是一份一百年後還有人讀的中文文件——記錄這一代裡把全部押在一件事上的人，記錄他們在那一刻的勇氣，記錄「梭哈」這個詞曾經被嚴肅地、認真地、不帶嘲諷地使用過。',
      ],
      pullQuote: '被記下，是一種古老的獎勵。它比 token 古老得多，可能也持久得多。',
      sign: '——ALLIN 社群，2026 年春天',
    },
  ],
};
